<template>
  <div class="pagination" v-if="showPagination">
    <span class="pagination-text">
      {{ resultPerPageLabel }}
    </span>
    <Select
      v-if="showSelect"
      class="pagination-select"
      :options="rowsPerPageOptions"
      :option="rowsPerPage"
      @change="handleChangeRowsPerPage"
      data-testid="pagination-select"
      :dropdownDirection="dropdownDirection"
    />
    <span class="pagination-pages">{{ displayPages }}</span>
    <template v-if="showChangesPages">
      <button
        class="chevron back"
        @click="handlePageBack"
        :disabled="disableBackButton"
        data-testid="pagination-back"
      />
      <button
        class="chevron next"
        @click="handlePageNext"
        :disabled="disableNextButton"
        data-testid="pagination-next"
      />
    </template>
  </div>
</template>

<script>
import Select from '../Select/Select.vue';

export default {
  components: { Select },
  props: {
    rowsNumber: { type: Number, default: 0 },
    rowsPerPage: { type: Number, default: 15 },
    startRow: { type: Number, default: 0 },
    resultPerPageLabel: { type: String, default: 'Results per page' },
    dropdownDirection: { type: String, default: 'bottom' },
  },
  data() {
    return {
      rowsPerPageOptions: [3, 5, 7, 10, 15, 20, 25, 50],
    };
  },
  computed: {
    page() {
      if (this.startRow < this.rowsPerPage) {
        return 1;
      }
      return this.startRow / this.rowsPerPage + 1;
    },
    totalPages() {
      if (this.rowsNumber < this.rowsPerPage) {
        return 1;
      }
      return Math.ceil(this.rowsNumber / this.rowsPerPage);
    },
    displayPages() {
      return `${this.page} - ${this.totalPages}
        ${this.$t('general.table.pagination_connector')}
        ${this.rowsNumber} `;
    },
    disableBackButton() {
      return this.page === 1;
    },
    disableNextButton() {
      return this.page === this.totalPages;
    },
    showChangesPages() {
      return this.rowsPerPage < this.rowsNumber;
    },
    showSelect() {
      return this.rowsNumber > this.rowsPerPageOptions[0];
    },
    showPagination() {
      return this.rowsNumber !== 0;
    },
  },
  methods: {
    handleChangeRowsPerPage(value) {
      this.$emit('onChangeRowsPerPage', value);
    },
    handlePageBack() {
      this.$emit('onChangePage', this.changePage(this.page - 2));
    },
    handlePageNext() {
      this.$emit('onChangePage', this.changePage(this.page));
    },
    changePage(pageToCheckStartRow) {
      return {
        startRow: pageToCheckStartRow * this.rowsPerPage,
      };
    },
  },
};
</script>

<style scoped lang="scss">
.pagination {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-top: var(--track-spacing-md);
  border-top: 1px solid var(--track-color-gray-lightest);
  padding-top: var(--track-spacing-sm);
  height: 38px;

  ::v-deep .select-container .cxm-Input-ContentWithIcon {
    border: 0;
    &::after {
      background-color: rgba(0, 0, 0, 0.54);
    }
    svg {
      fill: black;
    }
  }

  ::v-deep .select-container .cxm-Input-Base {
    color: black;
  }

  .chevron {
    border: none;
    background: transparent;
    cursor: pointer;
    width: 35px;
    height: 35px;
    transition: background-color 0.5s;
    border-radius: 100%;

    &:hover {
      background: rgb(97, 97, 97, 0.1);
    }
  }

  .chevron::before {
    border-style: solid;
    border-width: 0.2em 0.2em 0 0;
    content: "";
    display: inline-block;
    height: 0.65em;
    left: 0.15em;
    position: relative;
    top: 0.15em;
    transform: rotate(-45deg);
    vertical-align: top;
    width: 0.65em;
    border-color: #616161;
  }

  .back:before {
    left: 0.25em;
    transform: rotate(-135deg);
  }
  .next:before {
    left: 0;
    transform: rotate(45deg);
  }
}
.pagination-text {
  color: black;
  font-size: 12px;
  font-weight: normal;
}
.pagination-pages {
  color: black;
  font-size: 12px;

  .pagination-text + & {
    margin-left: var(--track-spacing-md);
  }
}
.pagination-select {
  width: 85px;
  cursor: pointer;
}
</style>
